import { useRecoilValue } from "recoil";
import { timeFormatAtom } from "../recoil/timeFormat";
import moment from "moment";

// LOCAL 시간 형식으로 포맷
const toLOCAL = (time) => {
  if (!time) return "";
  const result = moment(time).format("YYYY-MM-DD HH:mm:ss");
  return result;
};

// UTC 문자열을 다시 LOCAL로 변환
const toLOCALatReal = (time) => {
  if (!time) return "";
  const result2 = toUTCFormat(time);
  const result = moment(result2).format("YYYY-MM-DD HH:mm:ss");
  return result;
};

// UTC 포맷으로 변환
const toUTC = (inputDate) => {
  if (!inputDate) return "";
  const dateObject = new Date(inputDate);
  if (isNaN(dateObject)) return "";
  const formattedDate = dateObject
    .toISOString()
    .replace(/T/, " ")
    .replace(/\..+/, "");
  return formattedDate;
};

// 문자열을 ISO UTC 포맷으로 변환 (예: "2025-06-26T08:10:00Z")
const toUTCFormat = (time) => {
  if (!time || typeof time !== "string") return "";
  if (time.length < 19) return ""; // "YYYY-MM-DD HH:mm:ss" 최소 길이 보장
  return time.slice(0, 10) + "T" + time.slice(11) + "Z";
};

// UTC 여부에 따라 시간 포맷 결정
export const useTimeFormat = () => {
  const isUTC = useRecoilValue(timeFormatAtom);
  const formatDate = (time) => {
    return isUTC === "utc" ? toUTC(time) : toLOCAL(time);
  };
  return {
    date: formatDate,
  };
};

// UTC 여부에 따라 그대로 사용하거나 local 변환
export const useTimeFormatReal = () => {
  const isUTC = useRecoilValue(timeFormatAtom);
  const formatDate = (time) => {
    return isUTC === "utc" ? (time || "") : toLOCALatReal(time);
  };
  return {
    date: formatDate,
  };
};
